import React, { useState, useEffect } from "react";
import AccountService from "../../Services/AccountService";
import { useAuth } from "../../Utils/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  faPlus,
  faFileAlt,
  faMinus,
  faEye,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GridCard from "../../common/gridCard";
import SingleCard from "../../common/singleCard";
import "./index.css";
import { customErrorHandler, toTitleCase } from "../../Utils/helper";
import Bank_Service from "../../Services/apiService/bank-service";
import FullScreenLoader from "../../Component/FullScreenLoader";
import NewPagination from "../../Component/DashBoard/NewPagination";
import AddEditBank from "./add-edit";
import bankService from "../../Services/apiService/bank-service";
import Confirmation_dialog from "../../Component/confirmation_dialog";
import AddBankBalance from "./balance/add_balance";
import WithdrawBankBalance from "./balance/withdraw_balance";
import RenewPermission from "../../Component/edit_permission";

const BankView = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [getbankName, setGetBankName] = useState([]);
  const [Id, setId] = useState();
  const [SId, setSId] = useState();
  const [SubAdmins, setSubAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState(""); // usestate for search state
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeCard, setActiveCard] = useState(null);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const pageLimit = 9;
  const [showAddEdit, setShowAddEdit] = useState(false);
  const [addEditDialogData, setAddEditDialogData] = useState({
    id: "",
    callingFor: "",
    dialogTitle: "",
    data: {},
  });
  const [renderParrent, setRenderParrent] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [showPermissionDialog, setShowPermissionDialog] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState({
    show : false ,
    data : '',
  });

  const [showWithdrawDialog, setShowWithdrawDialog] = useState({
    show : false ,
    data : '',
  });

    const [permissionToggle, setPermissionToggle] = useState(true); // need to do false while close
  


  const selectPageHandler = (selectedPage) => {
    console.log(selectedPage);
    setPage(selectedPage);
  };
  const confirmDialogInitialState = {
    show: false,
    title: "",
    message: "",
    confirmText: "",
    cancelText: "",
    isConfirm: false,
    isDenied: false,
    data : "",
    onSuccess : () => {}
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(
    confirmDialogInitialState
  );

  const initialFormState = {
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    accountHolderName: "",
    upiId: "",
    upiAppName: "",
    upiPhoneNumber: "",
  };
  const [formData, setFormData] = useState(initialFormState);

  const startIndex = Math.min((page - 1) * pageLimit + 1);
  const endIndex = Math.min(page * pageLimit, totalData);

  const handleCardClick = (id) => {
    setActiveCard(id);
    setTimeout(() => setActiveCard(null), 300); // Reset the animation class after animation duration
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handelstatement = (e, accountNumber) => {
    console.log("first", accountNumber);
    navigate(`/bankstatement/${accountNumber}`);
  };

  const handleDeleteBank = (id) => {
      AccountService.deletebank({ requestId: id }, auth.user)
        .then((res) => {
          console.log("res", res);
          if (res.status === 201) {
            toast.success(res.data.data.message);
            // No immidiate effect thats why not calling get api
          }
        })
        .catch((error) => {
          toast.error(customErrorHandler(error));
          console.log(error);
        });
    
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await Bank_Service.getAllBanks(
        auth.user,
        page,
        search,
        pageLimit
      );
      const data = res?.data?.data.filter((item)=> item.isView !== 0)
      setGetBankName(data);
      if(data?.length){
      setTotalData(res?.data?.pagination?.totalItems);
      setTotalPage(res?.data?.pagination?.totalPages);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handelId = (id) => {
    setId(id);
  };

  const handelPermissionDialogOpen = (subAdmins, id) => {
    setSubAdmins(subAdmins);
    setSId(id);
    setShowPermissionDialog(true)
  };

  const handelActiveBank = (id) => {
      const flag = true;
      const data = {
        isActive: flag,
      };
      AccountService.activeInactiveBank(id, data, auth.user)
        .then((response) => {
          toast.success(response.data.message || "Bank Activated");
         
          const getbankNameUpdated = JSON.parse(JSON.stringify(getbankName));
          //  debugger;
          getbankNameUpdated.forEach((bank) => {
            if (bank.bankId === id) {
              bank.isActive = 1;
            }
          });
          setGetBankName(getbankNameUpdated);
        })
        .catch((error) => {
          toast.error(customErrorHandler(error));
       });
    
  };

  const handelInactiveBank = (id) => {
      const flag = false;
      const data = {
        isActive: flag,
      };
      AccountService.activeInactiveBank(id, data, auth.user)
        .then((response) => {
          toast.success(response.data.message || "Bank Inactivated ");
          const getbankNameUpdated = JSON.parse(JSON.stringify(getbankName));
          getbankNameUpdated.forEach((bank) => {
            if (bank.bankId === id) {
              bank.isActive = 0;
            }
          });
          setGetBankName(getbankNameUpdated);
          console.log(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    
  };

  useEffect(() => {
    setGetBankName([]);
    fetchData();
  }, [debouncedSearch, page, renderParrent]);

  useEffect(() => {
  const timerId = setTimeout(() => {
    setDebouncedSearch(search);
  }, 300); 

  return () => {
    clearTimeout(timerId);
  };
}, [search]);

  const handleAddBank = () => {
    setAddEditDialogData((prev) => ({
      ...prev,
      callingFor: "Add",
      dialogTitle: "Add New Bank",
    }));
    setShowAddEdit(true);
  };

  const handleEditBank = (data) => {
    setFormData((prev) => ({
      ...prev,
      bankName: data?.bankName,
      accountNumber: data?.accountNumber,
      ifscCode: data?.ifscCode,
      accountHolderName: data?.accountHolderName,
      upiId: data?.upiId,
      upiAppName: data?.upiAppName,
      upiPhoneNumber: data?.upiNumber,
    }));
    setShowAddEdit(true);
    setAddEditDialogData((prev) => ({
      ...prev,
      id: data.bankId,
      callingFor: "Edit",
      dialogTitle: "Edit Bank",
      data: data,
    }));
  };

  const handleAddEditModalClose = () => {
    setFormData(initialFormState);
    setShowAddEdit(false);
  };

  const handleAddEditSubmit = () => {
    addEditDialogData.callingFor === "Add"
      ? bankService
          .addBank(formData, auth.user)
          .then((response) => {
            toast.success(response.data.message);
            handleAddEditModalClose();
            // setRenderParrent(response)
            // commented beacuse we dont have any immidiate effect on UI
          })
          .catch((error) => {
            toast.error(customErrorHandler(error));
            console.error(error);
          })

      : 
      // debugger;
      bankService
          .editBank(formData, addEditDialogData.id, auth.user)
          .then((response) => {
            console.log(response.data);
            toast.success("Edit Request Send Successfully!");
            // setRenderParrent(response)
            // commented beacuse we dont have any immidiate effect on UI
            handleAddEditModalClose();
          })
          .catch((error) => {
            console.error("err=>>>>", error);
            toast.error(customErrorHandler(error));
          });
  };

  const handleConfirmDialogOpen = ( message, confirmText, cancelText , data , onConfirm) => {
    setShowConfirmDialog((state) => ({
      ...state,
      show: true,
      message: toTitleCase(message),
      confirmText: confirmText,
      cancelText: cancelText,
      data : data ,
      onSuccess : onConfirm
    }));
  };

  const handleConfirmDialogClose = () => {
    setShowConfirmDialog(confirmDialogInitialState);
  };

  const handleOpenAddDialog = (data) =>{
    setShowAddDialog((state)=>({
      ...state,
      show : true,
      data : data
    }))
  }


  const handleOpenWithdrawDialog = (data) =>{
    setShowWithdrawDialog((state)=>({
      ...state,
      show : true,
      data : data
    }))
  }


  const handleCloseAddDialog = () => {
      setShowAddDialog((state) => ({
        ...state,
        show: false
      }))
  }
    
  const handleCloseWithdrawDialog = () => {
    setShowWithdrawDialog((state) => ({
      ...state,
      show: false,
    }));
  };

  const submitPermissionChange = (data, id) => {
    bankService.permissionRenewBank(data, id, auth.user)
      .then((response) => {
        toast.success(toTitleCase(response.data.message || 'Success'));
        // const getbankNameUpdated = JSON.parse(JSON.stringify(getbankName));
        // getbankNameUpdated.forEach((bank) => {
        //   if (bank.bankId === id) {
        //     bank.subAdmins = data.subAdmins;
        //   }
        // });
        // setGetBankName(getbankNameUpdated);
        handleClosePermissionDialog();
        setRenderParrent(response.data)
      })
      .catch((error) => {
        console.error(error);
        toast.error(toTitleCase(customErrorHandler(error)));
      });
  }

  const handleClosePermissionDialog = () => {
    setShowPermissionDialog(false);
    setPermissionToggle(true);
  }

  return (
    <div className="bg-white">
      <div
        className="card text-center mt-2 mr-5 ml-5 mb-2"
        style={{
          backgroundColor: "#e6f7ff",
          position: "relative",
        }}
      >
        <FullScreenLoader show={isLoading} />
        <SingleCard
          style={{
            backgroundColor: "#e6f7ff",
            position: "relative",
          }}
        >
          <div className="card-header-pill text-bold d-flex ">
            <div className="flex-grow-1 ">
              <input
                type="text"
                className="form-control rounded-pill shadow"
                placeholder="Search Bank Name"
                value={search}
                onChange={handleSearch}
              />
            </div>
            <div className="flex-grow-1 d-flex justify-content-end position-relative">
              <h5
                className="mr-5"
                style={{
                  color: "#B0A295", // Matching the background color of the button
                  fontSize: "1.5rem", // Adjust the size to fit well within the header
                  margin: "0", // Remove default margin
                  lineHeight: "2.5rem", // Align vertically with the button
                  fontWeight: "bold", // Make the text thicker
                  fontFamily: "'Abril Fatface', serif ",
                }}
              >
                Add Bank
              </h5>
              <div
                className="input-icon-web-add position-absolute top-50 translate-middle-y d-flex align-items-center justify-content-center rounded-circle"
                onClick={handleAddBank}
                style={{
                  width: "2.5rem",
                  height: "2.5rem",
                  backgroundColor: "#4682b4",
                  color: "#fff",
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
              >
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </div>
          </div>
        </SingleCard>
        <div className="card-body  mt-2 mb-3">
          <SingleCard className="mb-2 p-4">
            <br></br>
            <GridCard columns={2}>
              {getbankName.map((data) => {
                const isInactive = !data.isActive;

                return (
                  <div
                    key={data.bankId}
                    className="col d-flex justify-content-center align-items-center "
                    onMouseEnter={() => setHoveredCard(data.bankId)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div
                      className={`card d-flex justify-content-between ${
                        hoveredCard === data.bankId ? "card-hover-shadow" : ""
                      }`}
                      style={{
                        borderRadius: "20px",
                        height: "200px",
                        width: "100%",
                        position: "relative",
                      }}
                      onClick={() => handleCardClick(data.bankId)}
                    >
                      <div className="card-body">
                        <p
                          className="font-weight-bold fs-4"
                          style={{ color: "#708090" }}
                        >
                          {data.bankName}
                          <br />
                          <span className="fs-5" style={{ color: "#A9A9A9" }}>
                            Balance: {data.balance}
                          </span>
                        </p>
                        <div className="container">
                          <div className="row g-1 justify-content-center mt-5">
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isWithdraw && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`} // Handling the css from Index css for disable if don't have permission
                                onClick={() => {
                                   handleOpenWithdrawDialog(data.bankId)
                                }}
                                title="Withdraw"
                              >
                                <FontAwesomeIcon
                                  icon={faMinus}
                                  className="add-icon"
                                />                          
                              </button>
                            </div>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isDeposit && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                onClick={() => {
                                  handleOpenAddDialog(data.bankId)
                                }}
                                title="Deposit"
                              >
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  className="add-icon"
                                />
                              </button>
                            </div>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className="btn btn-steel-blue btn-sm btn-hover-zoom"
                                onClick={(e) => {
                                  handelstatement(e, data.bankId);
                                }}
                                title="Statement"
                              >
                                <FontAwesomeIcon
                                  icon={faFileAlt}
                                  className="add-icon"
                                />
                              </button>
                            </div>

                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isEdit && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                onClick={() => handleEditBank(data)}
                                title="Edit Bank"
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  data-toggle="modal"
                                  data-target="#exampleModalCenter"
                                />
                              </button>
                            </div>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isDelete ? "" : "avoid-clicks"
                                }`}
                                onClick={() => {
                                  handleConfirmDialogOpen(
                                "are you sure you want to delete this bank ?",
                                "Yes",
                                "Cancel",
                                data.bankId,
                                handleDeleteBank
                              );
                                }}
                                title="Delete"
                              >
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  className="delete-icon"
                                />
                              </button>
                            </div>

                            <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                              <button
                                type="button"
                                className={`btn btn-steel-blue btn-sm btn-hover-zoom ${
                                  data.isRenew && !isInactive
                                    ? ""
                                    : "avoid-clicks"
                                }`}
                                data-toggle="modal"
                                data-target="#RenewBankPermission"
                                onClick={() => {
                                  handelPermissionDialogOpen(data.subAdmins, data.bankId);
                                }}
                                title="Renew Permission"
                              >
                                <FontAwesomeIcon
                                  icon={faEye}
                                  className="permission"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-position-top-right">
                        {data.isActive === 1 ? (
                          <span
                            type="button"
                            className="badge-pill badge-success   btn-hover-scale   "
                            title="Click To Inactive"
                                onClick={() => {
                              handleConfirmDialogOpen(
                                
                                "are you sure you want to inactive this bank ?",
                                "Yes",
                                "Cancel",
                                data.bankId,
                                handelInactiveBank
                              );
                            }}
                          >
                            Active
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="active-icon ms-1"
                            />
                            <span className="position-absolute top-0 start-100 translate-middle"></span>
                          </span>
                        ) : (
                          <span
                            type="button"
                            className="badge-pill badge-secondary  btn-hover-scale"
                            title="Click To Active"
                            onClick={() => {
                              handleConfirmDialogOpen(
                                "are you sure you want to active this bank ?",
                                "Yes",
                                "Cancel",
                                data.bankId,
                                handelActiveBank
                              );
                            }}
                          >
                            Inactive
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              className="active-icon ms-1"
                            />
                            <span className="dot-merged position-absolute top-0 start-100 translate-middle"></span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </GridCard>
           { getbankName.length === 0 && 
              <div className="d-flex justify-content-center align-items-center text-danger">No Banks Found</div>
               }
            {getbankName.length > 0 && (
              <NewPagination
                currentPage={page}
                totalPages={totalPage}
                handlePageChange={selectPageHandler}
                startIndex={startIndex}
                endIndex={endIndex}
                totalData={totalData}
              />
            )}
          </SingleCard>
        </div>
        <AddBankBalance
          state = {showAddDialog}
          setState = {setShowPermissionDialog}
          renderParent={setRenderParrent}
          setPage={setPage}
          handleClose = {handleCloseAddDialog}
        />
        <WithdrawBankBalance
          state = {showWithdrawDialog}
          setState = {setShowWithdrawDialog}
          renderParent={setRenderParrent}
          setPage={setPage}
          handleClose = {handleCloseWithdrawDialog}
        />
        <AddEditBank
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          show={showAddEdit}
          handleClose={() => handleAddEditModalClose()}
          addEditDialogData={addEditDialogData}
          setFormData={setFormData}
          formData={formData}
          handleSubmit={handleAddEditSubmit}
        />
        <RenewPermission
          SubAdmins={SubAdmins}
          ID={SId}
          state={getbankName}
          setState={setGetBankName}
          show={showPermissionDialog}
          handleClose={handleClosePermissionDialog}
          onSubmit={submitPermissionChange}
          toggle={permissionToggle}
          setToggle={setPermissionToggle}
        />
        <Confirmation_dialog
          show={showConfirmDialog.show}
          title={showConfirmDialog.title}
          message={showConfirmDialog.message}
          confirmText={showConfirmDialog.confirmText}
          cancelText={showConfirmDialog.cancelText}
          state = {showConfirmDialog}
          onSuccess={showConfirmDialog.onSuccess}
          handleConfirmDialogClose = {handleConfirmDialogClose}
        />
      </div>
    </div>
  );
};

export default BankView;
